import React, { useEffect, useState, useRef, useCallback } from "react";
import { FaCopy, FaCheck, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import refferalIcon from "../assets/img/referral-pic.svg";
import { loadDashboardData } from "../api/apiService";
import LiveTradingChart from "./LiveTradingChart";
import CappingStatusBar from "./CappingStatusBar";
import BuyIco from "../pages/BuyPackages/BuyIco";
import Loader from "../components/Loader";
import QRIcon from "../assets/img/qr.svg";
import Chart from "react-apexcharts";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import usdt_log from "../assets/img/usdt.png";
import trustwallet from "../assets/img/trustwallet.svg";
import MetaMask from "../assets/img/MetaMask.svg";
import walletconnect from "../assets/img/walletconnect.png";

import AlertMessage from "../components/AlertMessage";
import { useToken } from "../components/TokenContext";


import CappingBar from "../components/CappingBar";
import Bonanzaa from "../components/Bonanzaa";

import IncomeCard from "../components/IncomeCard";

import { useAppKitAccount } from "@reown/appkit/react";
import { BNBUSDTContract } from "../config/contractConfig";

import BNBUSDTContarctABI from "../abis/BNBUSDTContractABI.json";
import { useConnectorClient } from "wagmi";

import Web3 from "web3";


export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [referralLink, setReferralLink] = useState(null);
  const [MEMBERPOPDESCRIPTION, setMEMBERPOPDESCRIPTION] = useState("");
  const [MEMBERPOPIMAGE, setMEMBERPOPIMAGE] = useState("");
  const [MEMBERPOPTITLE, setMEMBERPOPTITLE] = useState("");
  const [MEMBERPOPSTATUS, setMEMBERPOPSTATUS] = useState("");
  const { jwtToken, fetchToken } = useToken();
  const [timeLeft, setTimeLeft] = useState("");
  const countdownRef = useRef(null);
  const fetchDashboard = async () => {
    setLoading(true);
    try {
      const currentToken = jwtToken || (await fetchToken());
      if (!currentToken) return;
      const loginToken = localStorage.getItem("LoginToken") || currentToken;
      const data = await loadDashboardData(currentToken, loginToken);
      setDashboardData(data);
      setMEMBERPOPDESCRIPTION(data.Dashboard.MEMBERPOPDESCRIPTION);
      setMEMBERPOPTITLE(data.Dashboard.MEMBERPOPTITLE);
      setMEMBERPOPIMAGE(data.Dashboard.MEMBERPOPIMAGE);
      setMEMBERPOPSTATUS(data.Dashboard.MEMBERPOPSTATUS);
      setReferralLink('https://login.bitwavecapital.io/Register?Referralcode=' + data.Dashboard.WALLETADDRESS)
    }
    catch (err) {
      setDashboardData(null);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, [jwtToken]);

  // Copy Function
  const handleCopy = (value, fieldKey) => {
    if (!value) return;
    navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopiedField(fieldKey);

        // Reset after 2 seconds
        setTimeout(() => setCopiedField(null), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  /******************************** */

  const [copiedField, setCopiedField] = useState("");

  /******************************** */

  // Build Pie Chart Helper
  const buildPie = (title, labels, values) => {
    const total = values.reduce((s, v) => s + (Number(v) || 0), 0);
    return {
      series: values,
      options: {
        chart: { type: "pie", toolbar: { show: false } },
        labels,
        legend: { position: "bottom" },
        tooltip: {
          y: {
            formatter: (val) => {
              const percent = total ? ((val / total) * 100).toFixed(1) : 0;
              return `${val} (${percent}%)`;
            },
          },
        },
        title: {
          text: title,
          align: "center",
          style: { fontSize: "16px", fontWeight: 600 },
        },
        responsive: [
          {
            breakpoint: 640,
            options: {
              chart: { width: "100%" },
              legend: { position: "bottom" },
            },
          },
        ],
      },
    };
  };

  // Token Wallet Chart
  const tokenChart = buildPie(
    "",
    ["Credited", "Used", "Available"],
    [
      dashboardData?.Dashboard?.CREDITTOKENWALLET || 0,
      dashboardData?.Dashboard?.USEDTOKENWALLET || 0,
      dashboardData?.Dashboard?.AVAILABLETOKENWALLET || 0,
    ]
  );

  // USDT Wallet Chart
  const usdtChart = buildPie(
    "",
    ["Credited", "Used", "Available"],
    [
      dashboardData?.Dashboard?.CREDITBONUSWALLET || 0,
      dashboardData?.Dashboard?.USEDBONUSWALLET || 0,
      dashboardData?.Dashboard?.AVAILABLEBONUSWALLET || 0,
    ]
  );



  /******************************** */


  // Correct Arrow Definitions Inline
  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="PrevArrow" onClick={onClick}
      >
        &#9650; {/* Up arrow */}
      </div>
    );
  };

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="NextArrow"
      >
        &#9660; {/* Down arrow */}
      </div>
    );
  };

  // Slick Settings With Auto Slide
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    autoplay: false,         // Enable Auto Slide
    autoplaySpeed: 3000,    // Slide Every 3 Seconds
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } }
    ]
  };

  /*********************************/

  const [isCopied, setIsCopied] = useState(false);
  const myReferralLink = referralLink;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(myReferralLink)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      })
      .catch((err) => console.error("Copy failed:", err));
  };

  const shareOnWhatsApp = () => {
    const waUrl = `https://wa.me/?text=${encodeURIComponent(myReferralLink)}`;
    window.open(waUrl, "_blank");
  };

  const shareOnTelegram = () => {
    const tgUrl = `https://t.me/share/url?url=${encodeURIComponent(myReferralLink)}`;
    window.open(tgUrl, "_blank");
  };


  /*********************************/


  /////////////////////////////////////
  //Section Start For Package Purchase

  const [selectedCoin, setSelectedCoin] = useState(null);
  const [payMode, setPayMode] = useState("qr");
  const [walletData, setWalletData] = useState(null); // store API wallet response
  const [copiedWallet, setCopiedWallet] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [reactalert, setAlert] = useState({ type: "", message: "" });

  const copyWallet = (wallet) => {
    navigator.clipboard.writeText(wallet);
    setCopiedWallet(wallet);
    setTimeout(() => setCopiedWallet(null), 2000);
  };

  const pollingRef = useRef(null);


  const { address } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);

  useEffect(() => {
    let provider = null;
    if (client && client.transport) {
      provider = client.transport;
    } else if (typeof window !== "undefined" && window.ethereum) {
      provider = window.ethereum;
    }
    if (provider) {
      try {
        const w3 = new Web3(provider);
        setWeb3(w3);
        if (provider.removeAllListeners) provider.removeAllListeners();
      } catch {
        setWeb3(null);
      }
    } else {
      setWeb3(null);
    }
    return () => {
      if (provider && provider.removeAllListeners) provider.removeAllListeners();
    };
  }, [client]);


  //////////////////////////////////////////////////
  //Modal PopUp
  const [promoOpen, setPromoOpen] = useState(false);

  useEffect(() => {
    const nav = window.performance.getEntriesByType("navigation")[0];

    // Page reload hone par popup open
    if (nav && nav.type === "reload") {
      setTimeout(() => {
        setPromoOpen(true);
      }, 800);
    }
  }, []);

  const closePromo = () => {
    setPromoOpen(false);
  };



  function formatTime(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  }
  if (loading) {
    return <Loader />;
  }
  return (
    <>

      {MEMBERPOPSTATUS == 1 && (
        <>
          {/* Overlay */}
          {promoOpen && (
            <div
              className={`promoOverlay ${promoOpen ? "show" : ""}`}
              onClick={closePromo}
            ></div>
          )}

          {/* Popup Box */}
          <div className={`promoPopupWrapper ${promoOpen ? "open" : ""}`}>
            {promoOpen && (
              <div className="promoPopupBox">

                <h3 className="text-warning mb-2">🎉 {MEMBERPOPTITLE} 🎉</h3>

                <img src={MEMBERPOPIMAGE} alt="promo" />

                <div
                  className="mt-2"
                  dangerouslySetInnerHTML={{ __html: MEMBERPOPDESCRIPTION }}
                />

                <button className="promoCloseBtn" onClick={closePromo}>
                  Close
                </button>

              </div>
            )}
          </div>
        </>
      )}

      <div className="pageTitle"> Dashboard</div>
      {/* {dashboardData?.Dashboard?.ACTIVE === 1 && ( */}


      <div className="row">

        {/* {isCopied && <div className="text-success fw-bold  mb-4">✅ Link Copied!</div>} */}
        <div className="col-md-8 mb-4">
          <div className="refferalIcon-row">
            <img src={refferalIcon} alt="Referral" className="refferal-pic" />
            <div className="refferal-input-area">
              <div className="input-refferal">
                <input className="form-control" type="text" readOnly value={myReferralLink} />
                <button className="copybutton" type="button" onClick={copyToClipboard}>
                  {isCopied ? <FaCheck color="green" /> : <FaCopy />}
                </button>
              </div>
              <div className="d-flex gap-2">
                <button className="d-flex gap-2 btn btn-success  align-items-center flex-fill" onClick={shareOnWhatsApp}>
                  <FaWhatsapp /> WhatsApp
                </button>
                <button className="btn btn-info d-flex  gap-2 align-items-center flex-fill" onClick={shareOnTelegram}>
                  <FaTelegramPlane /> Telegram
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
      {/* )} */}



      <IncomeCard />


      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card-buy-package">
            <div className="card">
              <div className="card-body pb-0">
                <BuyIco />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-4">
            <CappingBar />
          </div>
          <div className="mb-4">
            {/* <Bonanzaa /> */}
            <div className="= mb-4">
              <div className="card">
                <div className="card-boy">
                  <div className="sponsor-card">
                    <div className="sponsor-card-right">
                      <h4 className="mb-4 text-white">My Profile Details</h4>

                      {dashboardData?.Dashboard &&
                        (dashboardData.Dashboard.NAME ||
                          dashboardData.Dashboard.EMAILID ||
                          dashboardData.Dashboard.MOBILE ||
                          dashboardData.Dashboard.WALLETADDRESS) ? (
                        <div className="sponsor-fields">
                          {/* Loginid */}
                          {/*     <div className="field-row">
                        <div>
                          <div className="label">Loginid</div>
                          <div className="value">
                            <i className="fa-solid fa-user me-1"></i>{" "}
                            {dashboardData.Dashboard.LOGINID || "N/A"}
                          </div>
                        </div>
                        <button
                          className="copy-btn"
                          onClick={() =>
                            handleCopy(dashboardData.Dashboard.NAME, "myname")
                          }
                        >
                          {copiedField === "myname" ? <FaCheck /> : <FaCopy />}
                        </button>
                      </div> */}

                          {/* Name */}
                          {/*     <div className="field-row">
                        <div>
                          <div className="label">Name</div>
                          <div className="value">
                            <i className="fa-solid fa-user me-1"></i>{" "}
                            {dashboardData.Dashboard.NAME || "N/A"}
                          </div>
                        </div>
                        <button
                          className="copy-btn"
                          onClick={() =>
                            handleCopy(dashboardData.Dashboard.NAME, "myname")
                          }
                        >
                          {copiedField === "myname" ? <FaCheck /> : <FaCopy />}
                        </button>
                      </div> */}

                          {/* Contact */}
                          {/*     <div className="field-row">
                        <div>
                          <div className="label">Contact No.</div>
                          <div className="value">
                            <i className="fa-solid fa-mobile me-1"></i>{" "}
                            {dashboardData.Dashboard.MOBILE || "N/A"}
                          </div>
                        </div>
                        <button
                          className="copy-btn"
                          onClick={() =>
                            handleCopy(dashboardData.Dashboard.MOBILE, "mycontact")
                          }
                        >
                          {copiedField === "mycontact" ? <FaCheck /> : <FaCopy />}
                        </button>
                      </div> */}

                          {/* Email */}
                          {/*   <div className="field-row">
                        <div>
                          <div className="label">Email Id</div>
                          <div className="value">
                            <i className="fa-solid fa-envelope me-1"></i>{" "}
                            {dashboardData.Dashboard.EMAILID || "N/A"}
                          </div>
                        </div>
                        <button
                          className="copy-btn"
                          onClick={() =>
                            handleCopy(dashboardData.Dashboard.EMAILID, "myemail")
                          }
                        >
                          {copiedField === "myemail" ? <FaCheck /> : <FaCopy />}
                        </button>
                      </div> */}

                          {/* Wallet */}
                          <div className="field-row">
                            <div>
                              <div className="label">Wallet Address</div>
                              <div className="value wallet">
                                <i className="fa-solid fa-wallet me-1"></i>{" "}
                                {dashboardData.Dashboard.WALLETADDRESS || "N/A"}
                              </div>
                            </div>
                            <button
                              className="copy-btn"
                              onClick={() =>
                                handleCopy(dashboardData.Dashboard.WALLETADDRESS, "mywallet")
                              }
                            >
                              {copiedField === "mywallet" ? <FaCheck /> : <FaCopy />}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="text-center text-white">
                          No profile details found
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="= ">
              <div className="card Sponsor-Details-card">
                <div className="card-boy">
                  <div className="sponsor-card">
                    <div className="sponsor-card-right">
                      <h4 className="mb-4 text-white">Sponsor Details</h4>

                      {dashboardData?.Dashboard &&
                        (dashboardData.Dashboard.SPONSORNAME ||
                          dashboardData.Dashboard.SPONSOREMAILID ||
                          dashboardData.Dashboard.SPONSORMOBILENO ||
                          dashboardData.Dashboard.SPONSORWALLETADDRESS) ? (
                        <div className="sponsor-fields">
                          {/* Name */}
                          {/* <div className="field-row">
                        <div>
                          <div className="label">Sponsor Name</div>
                          <div className="value">
                            <i className="fa-solid fa-user me-1"></i>{" "}
                            {dashboardData.Dashboard.SPONSORNAME || "N/A"}
                          </div>
                        </div>
                        <button
                          className="copy-btn"
                          onClick={() =>
                            handleCopy(dashboardData.Dashboard.SPONSORNAME, "name")
                          }
                        >
                          {copiedField === "name" ? <FaCheck /> : <FaCopy />}
                        </button>
                      </div> */}

                          {/* Contact */}
                          {/*  <div className="field-row">
                        <div>
                          <div className="label">Contact No.</div>
                          <div className="value">
                            <i className="fa-solid fa-mobile me-1"></i>{" "}
                            {dashboardData.Dashboard.SPONSORMOBILENO || "N/A"}
                          </div>
                        </div>
                        <button
                          className="copy-btn"
                          onClick={() =>
                            handleCopy(dashboardData.Dashboard.SPONSORMOBILENO, "contact")
                          }
                        >
                          {copiedField === "contact" ? <FaCheck /> : <FaCopy />}
                        </button>
                      </div> */}

                          {/* Email */}
                          {/*   <div className="field-row">
                        <div>
                          <div className="label">Email Id</div>
                          <div className="value">
                            <i className="fa-solid fa-envelope me-1"></i>{" "}
                            {dashboardData.Dashboard.SPONSOREMAILID || "N/A"}
                          </div>
                        </div>
                        <button
                          className="copy-btn"
                          onClick={() =>
                            handleCopy(dashboardData.Dashboard.SPONSOREMAILID, "email")
                          }
                        >
                          {copiedField === "email" ? <FaCheck /> : <FaCopy />}
                        </button>
                      </div>
 */}
                          {/* Wallet */}
                          <div className="field-row">
                            <div>
                              <div className="label">Wallet Address</div>
                              <div className="value wallet">
                                <i className="fa-solid fa-wallet me-1"></i>{" "}
                                {dashboardData.Dashboard.SPONSORWALLETADDRESS || "N/A"}
                              </div>
                            </div>
                            <button
                              className="copy-btn"
                              onClick={() =>
                                handleCopy(
                                  dashboardData.Dashboard.SPONSORWALLETADDRESS,
                                  "wallet"
                                )
                              }
                            >
                              {copiedField === "wallet" ? <FaCheck /> : <FaCopy />}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="text-center text-white">
                          No sponsor details found
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>








      <div className="row"> 


        {/* <div className="col-md-6 mb-4">
          <div className="card">
            <div className="card-body">
              <h3 className="text-white mb-4">Token Details</h3> 

              <div className="row align-items-center">
                <div className="col-md-6">
                  <ul className="token-list">
                    <li className="credit-span">
                      <div>Credit</div>
                      <b>{dashboardData?.Dashboard?.CREDITTOKENWALLET || 0} GLT</b>
                    </li>
                    <li className="user-span">
                      <div>Used</div>
                      <b>{dashboardData?.Dashboard?.USEDTOKENWALLET || 0} GLT</b>
                    </li>

                    <li className="available-span">
                      <div>Available</div>
                      <b>{dashboardData?.Dashboard?.AVAILABLETOKENWALLET || 0} GLT</b>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <Chart options={tokenChart.options} series={tokenChart.series} type="pie" height={300} />
                </div>
              </div> 
            </div>
          </div>
        </div> 
        <div className="col-md-6 mb-4">
          <div className="card">
            <div className="card-body"> 
              <h3 className="text-white mb-4">USDT Details</h3>
            <div className="row align-items-center">
              <div className="col-md-6">
                  <ul className="token-list">
                    <li className="credit-span">
                      <div>Credit</div>
                      <b>{dashboardData?.Dashboard?.CREDITBONUSWALLET || 0} USDT</b>
                    </li>
                    <li className="user-span">
                      <div>Used</div>
                      <b>{dashboardData?.Dashboard?.USEDBONUSWALLET || 0} USDT</b>
                    </li>

                    <li className="available-span">
                      <div>Available</div>
                      <b>{dashboardData?.Dashboard?.AVAILABLEBONUSWALLET || 0} USDT</b>
                    </li>
                  </ul>
              </div>
              <div className="col-md-6">
                <Chart options={usdtChart.options} series={usdtChart.series} type="pie" height={300} />
              </div>
            </div> 
 </div> 
          </div>
        </div> */}


        <div className="col-md-12 mb-4">
          <div className="card">
            <div className="card-body">
              <h4 className="text-white">
                News & Updates{" "}
                <small className="capping-color ms-2">
                  ({dashboardData?.AggreMentDataList?.length || 0})
                </small>
              </h4>

              {dashboardData?.AggreMentDataList && dashboardData.AggreMentDataList.length ? (
                <Slider {...settings}>
                  {dashboardData.AggreMentDataList.map((news, idx) => (
                    <div key={idx} className="news-card">
                      <div className="settings-row">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="settings-pic">
                              {news?.IMAGE && news.IMAGE !== "" ? (
                                <img src={news.IMAGE} alt="news" />
                              ) : (
                                <img
                                  src="https://imagedelivery.net/DIa3rhuhOcNX43h6jPBQ1w/e9da1ca0-77da-4190-0c18-c628da30c300/public"
                                  alt="news"
                                />
                              )}
                            </div>
                          </div>

                          <div className="col-md-8">
                            <div className="news-tittle">
                              <h5>{news.SUBJECT}</h5>
                              <p className="date mb-1 badge bg-warning text-dark">
                                <i className="fa-solid fa-clock me-1"></i> {news.DATE}
                              </p>
                              <p
                                className="mb-1"
                                dangerouslySetInnerHTML={{ __html: news.NEWS }}
                              />
                              {/* <a href={news.link}>Read More</a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              ) : (
                <div className="text-center text-white">No news found</div>
              )}
            </div>
          </div>
        </div>
        {/* <LiveTradingChart /> */}

      </div>


    </>
  );
}
